module.exports = __webpack_public_path__ + "img/agma2015-2-B15_figB01_radial-composite-deviation-50z-4k.8cca16ed.png";